import { render } from "./LangPopup.vue?vue&type=template&id=fceff772&scoped=true"
import script from "./LangPopup.vue?vue&type=script&lang=js"
export * from "./LangPopup.vue?vue&type=script&lang=js"

import "./LangPopup.vue?vue&type=style&index=0&id=fceff772&scoped=true&lang=css"
import "./LangPopup.vue?vue&type=style&index=1&id=fceff772&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fceff772"]])

export default __exports__